import React from "react";
import { observable } from "mobx";
import { inject, observer } from "mobx-react";
import { IAuthStore } from "@src/Stores/Auth/types";
import { IValuesStore } from "@src/Stores/Values/types";
import { IManagementStore } from "Stores/Management/types";
import { Person, PositionAssignment } from "@src/Interfaces/Entity/Person";
import { Handover } from "@src/Interfaces/Entity/Handover";
import AppPreloader from "@src/Components/Common/AppPreloader/AppPreloader";
import CreateHandoverForm from "./CreateHandoverForm";
import PlainMessageForm from "./PlainMessageForm";
import PendingHandoverForm from "./PendingHandoverForm";
import _ from "lodash";

interface IProps {
  values?: IValuesStore;
  management?: IManagementStore;
  auth?: IAuthStore;
  onClose: () => void;
}

@inject("values", "management", "auth")
@observer
export default class HandoverForm extends React.Component<IProps> {  
  @observable isLoading: boolean = true;
  currentPerson: Person;
  handover: Handover;
  activePositionAssignment: PositionAssignment;

  async componentDidMount() {
    let currentPersonId = this.props.auth.user.person.id;
    await Promise.all([
      await this.props.management.getPerson(currentPersonId),
      await this.props.management.getPendingHandoverIfAny(),
      await this.props.management.getActiveLocations(),
      await this.props.management.getActivePositions(),
    ]).then(x => {
      this.currentPerson = x[0];
      this.handover = x[1];
      this.activePositionAssignment = this.getActivelyAssignedPosition();
      this.isLoading = false;
    });
  }

  getActivelyAssignedPosition(): PositionAssignment  {
    return _.find(this.currentPerson.positionAssignments, pa => {
      return pa.activelyAssigned && _.some(this.props.management.activeLocations, l => l.id == pa.locationId);
    });
  }

  render() {
    if (this.isLoading) {
      return <AppPreloader />;
    }

    if (_.isNil(this.activePositionAssignment)) {
      return <PlainMessageForm
        currentPerson={this.currentPerson}
        onClose={this.props.onClose}
        messageKey={"noActivePositionAssignment"}/>
    }

    if (this.activePositionAssignment.locationId != this.props.auth.user.location.id) {
      return <PlainMessageForm
        currentPerson={this.currentPerson}
        onClose={this.props.onClose}
        messageKey={"activePositionOnAnotherLocation"} />
    }

    if (this.handover == null) {
      return <CreateHandoverForm
        currentPerson={this.currentPerson}
        handover={this.handover}
        activePositionAssignment={this.activePositionAssignment}
        onClose={this.props.onClose} />;
    }

    return (
      <PendingHandoverForm
        currentPerson={this.currentPerson}
        handover={this.handover}
        onClose={this.props.onClose}/>
    );
  }
}
